import { useRef } from "react";
import { Row, Col } from "@/utils/bootstrap";
import SvgClearText from "./search-icons/SvgClearText";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";
import SvgNewHeaderSeachIcon from "./search-icons/SvgNewHeaderSeachIcon";
interface Props {
  active: boolean;
  setActive: (active: boolean) => void;
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  setShowDropdown: (show: boolean) => void;
  PC: boolean;
}
const NewHeaderSearchDropdownTitle: React.FC<Props> = ({
  PC = false,
  setActive,
  searchTerm,
  setSearchTerm,
  setShowDropdown,
}) => {
  const t = useTranslation();
  const ref = useRef<HTMLInputElement>(null);
  const router = useRouter();
  const gotoSearchPage = () => {
    setShowDropdown(false);
    router.push(`${PagesPaths.search}?q=${searchTerm}`);
  };
  return (
    <Row
      onClick={() => setActive(true)}
      className="m-0 align-items-center"
      style={{ gap: 8, width: PC ? 250 : undefined }}
    >
      <Col className="p-0">
        <input
          placeholder={t.search}
          ref={ref}
          autoFocus={PC}
          value={searchTerm}
          onKeyDown={(event) => {
            //@ts-ignore
            if (event.isComposing || event.key === 229) return;
            if (event.key === "Enter") gotoSearchPage();
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShowDropdown(!!searchTerm);
            setActive(true);
          }}
          onChange={(e) => {
            const val = e.target.value;
            setSearchTerm(val);
            setShowDropdown(!!val);
          }}
        />
      </Col>
      {searchTerm && (
        <Col className="p-0 col-auto">
          <SvgClearText
            onClick={() => {
              setSearchTerm("");
              setShowDropdown(false);
              ref.current?.focus();
              setActive(true);
            }}
          />
        </Col>
      )}
      <Col className="p-0 col-auto" style={{ marginInlineEnd: 4 }}>
        <SvgNewHeaderSeachIcon onClick={() => gotoSearchPage()} />
      </Col>
    </Row>
  );
};

export default NewHeaderSearchDropdownTitle;
